// removed by extract-text-webpack-plugin
module.exports = {"block":"_1PFFpIPXaOv5RCH0VFg0wO","bg":"_2K895bIg7PHaV7Op44p994"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BannersListBlock/BannersListBlock.module.scss
// module id = 734
// module chunks = 0